import React from "react";
import HeaderCities from "../components/HeaderCities";
import "../assets/css/header.css";
import "../assets/css/footer.css";
import "../assets/css/contact.css";

function BookOnline() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <base href="/" />
        <link rel="canonical" href="https://junkdroid.com/contact-us/" />
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Contact Cards  Section Start HERE =========================  */}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <iframe
                src="https://online-booking.workiz.com/?ac=2f3063010df7315df866536f0fa1a1f46be816ae2841d0100103eb5b69cf328f"
                width="100%"
                height="850px"
                style={{ border: "none" }}
                title="Booking Form"
              ></iframe>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default BookOnline;
